import moment from 'moment';
import { red, green, blue } from '@mui/material/colors';
import { find } from 'lodash';
import { getTelemetryGraphDateTimeFormat } from '../../../constants/telemetry';

export const isDemo = () => window.location.search.includes('demo') || window.location.host.includes('demo');

export const timeFormatter = (value, offset, isSameDay = true) => {
  const date = moment(value).utc().add(offset, 'hours');
  const format = getTelemetryGraphDateTimeFormat({ showDate: !isSameDay, dateInNewLine: true });

  return `${date.format(format)}`;
};

export const tooltipTimeFormatter = (value, offset) => {
  const format = getTelemetryGraphDateTimeFormat({ showDate: true });

  return moment(value).utc().add(offset, 'hours').format(format);
};

const plazaColors = {
  phaseA: red[400],
  phaseB: green[400],
  phaseC: blue[400],
};

export const getPlazaColorByPhase = (phase) => plazaColors[phase];

export const getPlazaNameByPhase = (settings, phase) => {
  const phases = settings.metrics.getMetrics();
  const currentPhase = find(phases, { phase });

  return currentPhase ? currentPhase.title : phase;
};
